import { ProfileOutlined } from '@ant-design/icons';

import PurchaseOrderPage from '../pages/PurchaseOrderPage';

import { SiteMap } from './index';

export const purchaseOrderRoutes: SiteMap = {
  'purchase-order': {
    title: '발주 관리',
    page: PurchaseOrderPage,
    icon: <ProfileOutlined />,
    key: '/purchase-order',
    children: [
      {
        label: '발주 미리보기',
        icon: null,
        key: '/purchase-order/preview',
      },
      {
        label: '발주서',
        icon: null,
        key: '/purchase-order/dashboard/table',
      },
      {
        label: '일일 출고 현황',
        icon: null,
        key: '/purchase-order/daily-outbound-transaction/table',
      },
    ],
  },
};
